import $ from "jquery";

const popupShop = () => {

    const el = {
        popup: $(".js-popup-shop"),
        openBtn: $(".js-popup-shop-open"),
        closeBtn: $(".js-popup-shop-close"),
        body: $("body")
    };

    const init = () => {
        execute();
    };

    const execute = () => {
        el.openBtn.on("click", function (e) {
            e.preventDefault();
            el.popup.addClass("active");
        });

        el.closeBtn.on("click", function (e) {
            e.preventDefault();
            el.popup.removeClass("active");
        });
    };

    init();
};

try {
    popupShop();
} catch (error) {
    console.error("popupShop", error);
}
